import { useDebugValue } from 'react';
import { useFieldState } from '../../../contexts';
import { useContentFieldPath } from '../fieldPaths/useContentFieldPath';

export const useContentErrors = () => {
  const fieldPath = useContentFieldPath();
  const { error } = useFieldState(fieldPath);
  useDebugValue(error);
  return error;
};
